export default "__VITE_ASSET__CLBd55R5__"